import { PolymerElement, html } from "@polymer/polymer/polymer-element";
import * as settings from "@polymer/polymer/lib/utils/settings";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";
import { MDCBanner } from "@material/banner";
import "@polymer/paper-styles/default-theme";
import "@polymer/app-layout/app-drawer/app-drawer";
import "@polymer/app-layout/app-drawer-layout/app-drawer-layout";
import "@polymer/app-layout/app-header/app-header";
import "@polymer/app-layout/app-header-layout/app-header-layout";
import "@polymer/app-layout/app-scroll-effects/app-scroll-effects";
import "@polymer/app-layout/app-toolbar/app-toolbar";
import "@polymer/app-route/app-location";
import "@polymer/app-route/app-route";
import "@polymer/iron-pages/iron-pages";
import "@polymer/iron-selector/iron-selector";
import "@polymer/paper-icon-button/paper-icon-button";
import "@polymer/paper-toggle-button/paper-toggle-button";
import "@polymer/paper-button/paper-button";
import "@polymer/iron-media-query/iron-media-query";
import "@polymer/paper-toast/paper-toast";
import "@polymer/paper-dropdown-menu/paper-dropdown-menu";
import "@polymer/paper-listbox/paper-listbox";
import "@polymer/paper-item/paper-item";
import { autorun } from "mobx";
import "@polymer/paper-menu-button/paper-menu-button";
import { getDefaultStore } from "./stores/root-store";
import "./custom-icons";
import "./control-item";
import "./google-analytics-autotrack";
import "./sign-up-page";
import "./submitted";
import "./resend-verification-email";
import "./error";
import "./make-api-request";
import "./nav-styles";
import "./site-document-management";
import * as env from "../env/env";
import { Group } from "./stores/app-state/store";
settings.setRootPath("/");
const defaultPage = {
    authRequired: true,
};
class App extends PolymerElement {
    static get template() {
        return html `
            <style include="nav-styles"></style>
            <link
                rel="stylesheet"
                href="node_modules/@material/banner/dist/mdc.banner.css"
            />
            <link
                rel="stylesheet"
                href="node_modules/@material/button/dist/mdc.button.css"
            />
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
            />
            <custom-style>
                <style is="custom-style" include="paper-material-styles">
                    :host {
                        --app-primary-color: #f1f1f1;
                        --app-secondary-color: black;
                        background-color: white;
                    }

                    #main {
                        height: calc(100vh - 64px);
                    }

                    app-drawer-layout:not([narrow]) [drawer-toggle] {
                        display: none;
                    }

                    app-header {
                        color: #fff;
                        /*background-color: var(--app-primary-color);*/
                        /*background-color: #f1f1f1;*/

                        /*--app-header-shadow: {*/
                        /*box-shadow: -1px 10px 5px 0px rgba(0,0,0,0.75);*/
                        /*};*/

                        /*box-shadow: -1px 4px 15px -5px rgba(89,89,89,1);*/
                    }

                    app-header paper-icon-button {
                        --paper-icon-button-ink-color: white;
                    }

                    .drawer-list {
                        margin: 0 20px;
                    }

                    .drawer-list a {
                        display: block;
                        padding: 0 16px;
                        text-decoration: none;
                        color: var(--app-secondary-color);
                        line-height: 40px;
                    }

                    .drawer-list a.iron-selected {
                        color: black;
                        font-weight: bold;
                    }

                    #logout-icon {
                        color: #272727;
                    }

                    #logout {
                        background-color: #f1f1f1;
                        height: 64px;
                    }

                    #logout:hover {
                        background-color: var(--paper-grey-300);
                    }

                    #logout:active {
                        background-color: var(--paper-grey-400);
                    }

                    #logout-text {
                        text-transform: uppercase;
                        color: #272727;
                        float: right;
                        position: relative;
                        font-weight: 300;
                        display: block;
                    }

                    .flex-container {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                    }

                    .table {
                        height: 100%;
                        width: 100%;
                        display: table;
                    }

                    .cell {
                        display: table-cell;
                        vertical-align: middle;
                    }

                    #dropdown-cell {
                        width: 1%;
                    }

                    #route-cell {
                        width: 200px;
                    }

                    #job-name-cell {
                        width: 10%;
                        color: #272727;
                    }

                    .route-text {
                        /*margin-left: 100px;*/
                        text-transform: uppercase;
                        color: #272727;
                        font-size: 20px;
                        font-weight: 400;
                        /*display: inline-block;*/
                        /*float: left;*/
                        /*position: relative;*/
                    }

                    .grey {
                        /*background-color: #f1f1f1;;*/
                        color: #272727;
                    }

                    .grey:hover {
                        background-color: #b1b1b1;
                    }

                    .userLink {
                        text-decoration: none;
                        color: black;
                    }

                    .userItem:hover {
                        background-color: #b1b1b1;
                    }

                    #theList {
                        margin: 0;
                        background-color: var(--app-primary-color);
                    }

                    #profile {
                        text-decoration: none;
                        border-right: solid;
                        border-color: #757575;
                        border-width: 1px;
                    }

                    #profile-btn {
                        padding-top: 5px;
                        padding-right: 11.4px;
                        padding-bottom: 5px;
                        padding-left: 11.4px;
                    }

                    body {
                        margin: 40px;
                    }

                    /*#roleSelection {*/
                    /*    width: 100px;*/
                    /*}*/

                    /*paper-dropdown-menu {*/
                    /*    --paper-input-container-input: {*/
                    /*        color: #272727;*/
                    /*        font-size: 20px;*/
                    /*        font-style: normal;*/
                    /*        text-align: right;*/
                    /*        text-transform: uppercase;*/
                    /*    } */
                    /*    --paper-input-container-underline: {*/
                    /*        display: none;*/
                    /*    };*/
                    /*}*/

                    /*#dropdownListBox {*/
                    /*    background-color: #f1f1f1;*/
                    /*}*/

                    a paper-button,
                    a:active paper-button,
                    a:visited paper-button {
                        color: #000;
                    }

                    .yellow-button {
                        text-transform: none;
                        color: #eeff41;
                    }

                    a[disabled] {
                        pointer-events: none;
                        cursor: default !important;
                    }

                    paper-item:hover {
                        font-weight: bold;
                        cursor: pointer;
                    }

                    paper-toast[type="error"] {
                        --paper-toast-background-color: var(--error-color);
                    }

                    .mdc-banner__content {
                        max-width: 100% !important;
                    }

                    .mdc-banner {
                        position: fixed !important;
                        --mdc-theme-surface: #ffbb33;
                    }

                    .mdc-banner__graphic {
                        --mdc-theme-primary: #ffffff;
                    }

                    .mdc-banner[type="warning"] {
                        position: fixed !important;
                        --mdc-theme-surface: #ffbb33;
                    }

                    .mdc-banner__graphic[type="warning"] {
                        --mdc-theme-primary: #ffffff;
                    }
                </style>
            </custom-style>

            <google-analytics-autotrack
                key="{{analyticsKey}}"
            ></google-analytics-autotrack>

            <iron-media-query
                query="(min-width: 640px)"
                query-matches="{{wide}}"
            ></iron-media-query>

            <app-location route="{{route}}"></app-location>
            <app-route
                route="{{route}}"
                pattern="[[rootPath]]:page"
                data="{{routeData}}"
                tail="{{subroute}}"
            ></app-route>
            <app-route
                route="{{subroute}}"
                pattern="/:id"
                data="{{subrouteData}}"
                tail="{{subsubroute}}"
            ></app-route>

            <div
                class="mdc-banner mdc-banner--mobile-stacked"
                role="banner"
                type$="[[bannerData.type]]"
            >
                <div class="mdc-banner__fixed">
                    <div
                        class="mdc-banner__content"
                        role="status"
                        aria-live="assertive"
                    >
                        <div class="mdc-banner__graphic-text-wrapper">
                            <template is="dom-if" if="[[bannerData.icon]]">
                                <div
                                    class="mdc-banner__graphic"
                                    role="img"
                                    alt=""
                                    type$="[[bannerData.type]]"
                                >
                                    <i class="material-icons mdc-banner__icon"
                                        >warning</i
                                    >
                                </div>
                            </template>
                            <div class="mdc-banner__text">
                                [[bannerData.title]]
                            </div>
                        </div>
                        <div class="mdc-banner__actions">
                            <template is="dom-if" if="[[bannerData.actions]]">
                                <button
                                    type="button"
                                    class="mdc-button mdc-banner__primary-action"
                                    data-action-id="0"
                                    on-click="onBannerAction"
                                >
                                    <div class="mdc-button__ripple"></div>
                                    <div class="mdc-button__label">
                                        [[bannerData.actions.0.text]]
                                    </div>
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <app-header-layout id="appHeaderLayout">
                <app-header
                    id="appHeader"
                    slot="header"
                    condenses=""
                    reveals=""
                    effects="waterfall"
                >
                    <app-toolbar>
                        <a
                            href$="{{cdnBaseUrl}}[[settings.rootPath]]site-dashboard"
                            id="home"
                        >
                            <img id="nav-logo" src="images/logo.png" />
                        </a>

                        <paper-dropdown-menu
                            id="roleSelection"
                            vertical-offset="60"
                        >
                            <paper-listbox
                                id="dropdownListBox"
                                slot="dropdown-content"
                                attr-for-selected="value"
                                selected="{{type}}"
                            >
                                <paper-item on-click="_typeChanged" value="jobs"
                                    >Jobs</paper-item
                                >
                                <template
                                    is="dom-if"
                                    if="{{permissions.admin}}"
                                >
                                    <paper-item
                                        on-click="_typeChanged"
                                        value="admin"
                                        >Admin</paper-item
                                    >
                                </template>
                                <template
                                    is="dom-if"
                                    if="{{featureEnabled(featureAccess, 'report')}}"
                                >
                                    <paper-item
                                        on-click="_typeChanged"
                                        value="report"
                                        >Report</paper-item
                                    >
                                </template>
                                <template
                                    is="dom-if"
                                    if="{{permissions.upload}}"
                                >
                                    <paper-item
                                        on-click="_typeChanged"
                                        value="upload"
                                        >Upload</paper-item
                                    >
                                </template>
                            </paper-listbox>
                        </paper-dropdown-menu>

                        <!--<h4 id="route-text">>[[page]]  ></h4>-->
                        <template is="dom-if" if="{{breadcrumbs}}">
                            <h4 class="route-text">
                                &nbsp;<iron-icon
                                    icon="custom-icons:chevron-right"
                                ></iron-icon>
                                &nbsp;{{breadcrumbs}}
                            </h4>
                        </template>

                        <div main-title=""></div>
                        <template is="dom-if" if="{{customConfig.logo}}">
                            <img id="nav-logo" src="[[customConfig.logo]]" />
                        </template>
                        <a
                            id="profile"
                            href$="{{cdnBaseUrl}}[[rootPath]]profile"
                        >
                            <paper-button id="profile-btn">
                                [[activeGroup.name]]
                                <iron-icon
                                    style="padding-left: 10px;"
                                    icon="custom-icons:person"
                                ></iron-icon>
                            </paper-button>
                        </a>
                        <paper-button
                            style="float: right;"
                            on-click="logout"
                            id="logout"
                        >
                            <h4 style="float: right;" id="logout-text">
                                LOG OUT &nbsp;
                            </h4>
                            <iron-icon
                                icon="custom-icons:keyboard-tab"
                                id="logout-icon"
                            ></iron-icon>
                        </paper-button>
                    </app-toolbar>
                </app-header>

                <!--Main Content-->
                <iron-pages
                    selected="[[page]]"
                    attr-for-selected="name"
                    selected-attribute="visible"
                    fallback-selection="view404"
                    role="main"
                    id="main"
                >
                    <site-dashboard
                        name="site-dashboard"
                        api-base-url="{{apiBaseUrl}}"
                        maps-api-key="{{mapsApiKey}}"
                        resource-token-info="{{resourceTokenInfo}}"
                        custom-config="{{customConfig}}"
                        store="[[rootStore]]"
                        active-group="{{activeGroup}}"
                        feature-access="{{featureAccess}}"
                    ></site-dashboard>
                    <user-profile
                        name="profile"
                        api-base-url="{{apiBaseUrl}}"
                        active-group="{{activeGroup}}"
                        store="[[rootStore]]"
                    ></user-profile>
                    <upload-dashboard
                        name="upload-dashboard"
                        api-base-url="{{apiBaseUrl}}"
                        store="[[rootStore]]"
                    ></upload-dashboard>
                    <site-viewer
                        name="site-viewer"
                        location="[[route]]"
                        job-id="{{siteViewerJobId}}"
                        controls="{{controls}}"
                        api-base-url="{{apiBaseUrl}}"
                        map-base-config="[[mapBaseConfig]]"
                        user-type="{{userType}}"
                        resource-token-info="{{resourceTokenInfo}}"
                        resource-token="{{resourceToken}}"
                        store="[[rootStore]]"
                    ></site-viewer>
                    <error-page name="error" error="[[error]]"></error-page>
                    <admin-page
                        name="admin"
                        api-base-url="{{apiBaseUrl}}"
                        group-id="[[groupId]]"
                        group-name="{{groupName}}"
                        route="{{subroute}}"
                        store="[[rootStore]]"
                    ></admin-page>
                    <report-page
                        name="report"
                        api-base-url="{{apiBaseUrl}}"
                        group-id="[[groupId]]"
                        group-name="{{groupName}}"
                        route="{{subroute}}"
                        store="[[rootStore]]"
                    ></report-page>
                    <simple-uploader
                        name="simple-uploader"
                        job-id="{{uploadJobId}}"
                        api-base-url="{{apiBaseUrl}}"
                        cdn-base-url="[[cdnBaseUrl]]"
                        store="[[rootStore]]"
                    ></simple-uploader>
                    <register-form
                        name="register"
                        api-base-url="{{apiBaseUrl}}"
                        form-data="{{theData}}"
                        site-key="[[siteKey]]"
                        registration-id="[[registrationId]]"
                    ></register-form>
                    <contact-us
                        api-base-url="{{apiBaseUrl}}"
                        name="contact-us"
                    ></contact-us>
                    <submitted-form
                        name="submitted"
                        api-base-url="{{apiBaseUrl}}"
                        data="[[theData]]"
                    ></submitted-form>
                    <resend-verification-email
                        name="resend-verification-email"
                        api-base-url="{{apiBaseUrl}}"
                        data="[[theData]]"
                    ></resend-verification-email>
                    <user-login
                        name="login"
                        tenant="[[tenant]]"
                        login-redirect-uri="[[loginRedirectUri]]"
                        client-id="[[clientId]]"
                        auth-return-redirect-uri="{{authReturnRedirectUri}}"
                    >
                    </user-login>
                    <auth-return
                        name="auth-return"
                        store="[[rootStore]]"
                        login-redirect-uri="[[loginRedirectUri]]"
                        api-base-url="{{apiBaseUrl}}"
                    ></auth-return>
                    <service-login
                        name="service-login"
                        login-redirect-uri="[[loginRedirectUri]]"
                        api-base-url="{{apiBaseUrl}}"
                        store="[[rootStore]]"
                    ></service-login>
                    <link-login
                        name="link"
                        login-redirect-uri="[[loginRedirectUri]]"
                        api-base-url="{{apiBaseUrl}}"
                        resource-token-info="{{resourceTokenInfo}}"
                        store="[[rootStore]]"
                    ></link-login>
                    <home-page
                        name="homepage"
                        error-message="[[errorMessage]]"
                        store="[[rootStore]]"
                    ></home-page>
                    <logout-page
                        name="logout"
                        tenant="[[tenant]]"
                        logout-redirect-uri="[[logoutRedirectUri]]"
                    ></logout-page>
                    <site-document-management
                        name="site-documents"
                        job-id="{{siteDocumentsJobId}}"
                        resource-token-info="{{resourceTokenInfo}}"
                        resource-token="{{resourceToken}}"
                        api-base-url="{{apiBaseUrl}}"
                        store="[[rootStore]]"
                    >
                    </site-document-management>
                    <my-view404 name="view404"></my-view404>
                </iron-pages>
            </app-header-layout>

            <paper-toast id="toast">
                <paper-button on-click="closeToast" class="yellow-button"
                    >Ok</paper-button
                >
            </paper-toast>

            <api-request
                id="apiRequest"
                url="[[url]]"
                params="[[params]]"
                authorization-required="[[authorizationRequired]]"
            ></api-request>
        `;
    }
    static get is() {
        return "web-app";
    }
    static get importMeta() {
        return import.meta;
    }
    static get properties() {
        return {
            rootPath: {
                type: String,
                value: settings.rootPath,
            },
            rootStore: {
                type: Object,
                value: getDefaultStore(true),
            },
            page: {
                type: String,
                reflectToAttribute: true,
                observer: "_pageChanged",
            },
            rootPattern: String,
            routeData: {
                type: Object,
                observer: "_routeDataChanged",
            },
            route: {
                type: Object,
                observer: "_routeChanged",
            },
            subroute: {
                type: String,
                observer: "_subrouteChanged",
            },
            controls: {
                type: Array,
                notify: true,
            },
            hideControls: Boolean,
            controlsOpened: {
                type: Boolean,
                value: true,
            },
            registrationId: {
                type: String,
            },
            theData: {
                type: Object,
                value: undefined,
                notify: true,
                observer: "_dataChange",
            },
            adminAuthorized: {
                type: Boolean,
                value: false,
            },
            type: {
                type: String,
                value: "jobs",
                observer: "_typeChanged",
            },
            apiBaseUrl: {
                type: String,
                notify: true,
                value: env.apiBaseUrl,
            },
            cdnBaseUrl: {
                type: String,
                notify: true,
                value: env.cdnBaseUrl,
            },
            analyticsKey: {
                type: String,
                notify: true,
                value: env.analyticsKey,
            },
            siteKey: {
                type: String,
                notify: true,
                value: env.siteKey,
            },
            tenant: {
                type: String,
                value: env.tenant,
            },
            mapsApiKey: {
                type: String,
                value: env.mapsApiKey,
            },
            logoutRedirectUri: {
                type: String,
                value: new URL(env.logoutRedirectUri, window.location),
            },
            loginRedirectUri: {
                type: String,
                value: new URL(env.loginRedirectUri, window.location),
            },
            clientId: {
                type: String,
                value: env.clientId,
            },
            authReturnRedirectUri: {
                type: String,
                value: "",
                notify: true,
            },
            errorMessage: {
                type: String,
                value: "",
            },
            uploadJobId: {
                type: String,
                value: "",
            },
            siteViewerJobId: {
                type: String,
                value: "",
            },
            siteDocumentsJobId: {
                type: String,
                value: "",
            },
            groupPageGroupName: {
                type: String,
                value: "",
            },
            toastText: {
                type: String,
                value: "",
            },
            activeGroup: {
                type: Object,
                value: {},
                observer: "activeGroupChanged",
            },
            userType: {
                type: String,
                observer: "_userTypeChanged",
            },
            featureAccess: {
                type: Array,
                value: [],
                notify: true,
            },
            resourceTokenInfo: {
                type: Object,
                value: {},
                observer: "resourceTokenChange",
            },
            refreshTokenCheckActive: {
                type: Boolean,
                value: false,
            },
            resourceToken: {
                type: String,
                notify: true,
            },
            customConfig: {
                type: Object,
                value: {},
                notify: true,
            },
            permissions: {
                type: Object,
            },
            updateAvailable: {
                type: Boolean,
                value: false,
                observer: "upgradeAvailableChanged",
            },
            bannerData: {
                type: Object,
                observer: "bannerDataChanged",
            },
            mapBaseConfig: {
                type: Array,
                value: [
                    {
                        name: "Dark",
                        templateUrl: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
                        options: {
                            id: "mapbox/dark-v10",
                            accessToken: env.mapboxToken,
                            maxNativeZoom: 18,
                            tileSize: 512,
                            zoomOffset: -1,
                            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                        },
                    },
                    {
                        name: "Light",
                        templateUrl: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
                        options: {
                            id: "mapbox/light-v10",
                            accessToken: env.mapboxToken,
                            maxNativeZoom: 18,
                            tileSize: 512,
                            zoomOffset: -1,
                            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                        },
                    },
                    {
                        name: "Street",
                        templateUrl: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
                        options: {
                            id: "mapbox/streets-v11",
                            accessToken: env.mapboxToken,
                            maxNativeZoom: 18,
                            tileSize: 512,
                            zoomOffset: -1,
                            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                        },
                    },
                    {
                        name: "Satellite",
                        templateUrl: "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
                        options: {
                            id: "mapbox/satellite-streets-v11",
                            accessToken: env.mapboxToken,
                            maxNativeZoom: 18,
                            tileSize: 512,
                            zoomOffset: -1,
                            attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                        },
                    },
                ],
            },
        };
    }
    static get observers() {
        return ["_routePageChanged(routeData.page)"];
    }
    static get pages() {
        return [
            {
                urlPath: "register",
                load: async () => import("./register.js"),
                authRequired: false,
            },
            {
                urlPath: "submitted",
                load: async () => import("./submitted.js"),
                authRequired: false,
            },
            {
                urlPath: "login",
                load: async () => import("./login.js"),
                authRequired: false,
            },
            {
                urlPath: "logout",
                load: async () => import("./logout.js"),
            },
            {
                urlPath: "auth-return",
                load: async () => import("./auth-return.js"),
                authRequired: false,
            },
            {
                urlPath: "service-login",
                load: async () => import("./service-login.js"),
                authRequired: false,
            },
            {
                urlPath: "link",
                load: async () => import("./link-login.js"),
                authRequired: false,
            },
            {
                urlPath: "homepage",
                load: async () => import("./homepage.js"),
                authRequired: false,
            },
            {
                urlPath: "resend-verification-email",
                load: async () => import("./resend-verification-email.js"),
                authRequired: false,
            },
            {
                urlPath: "site-dashboard",
                load: async () => import("./site-dashboard.js"),
            },
            {
                urlPath: "upload-dashboard",
                load: async () => import("./upload-dashboard.js"),
            },
            {
                urlPath: "simple-uploader",
                load: async () => import("./simple-uploader.js"),
            },
            {
                urlPath: "site-viewer",
                load: async () => import("./site-viewer.js"),
                authRequired: false,
            },
            {
                urlPath: "group-management",
                load: async () => import("./group-management.js"),
            },
            {
                urlPath: "profile",
                load: async () => import("./profile.js"),
            },
            {
                urlPath: "admin",
                load: async () => import("./admin.js"),
            },
            {
                urlPath: "report",
                load: async () => import("./report.js"),
            },
            {
                urlPath: "site-documents",
                load: async () => import("./site-documents.js"),
            },
            {
                urlPath: "error",
                load: async () => import("./error.js"),
                authRequired: false,
            },
            {
                urlPath: "view404",
                load: async () => import("./view404.js"),
            },
        ];
    }
    constructor() {
        super();
        this.pageDefs = this.constructor.pages.map((p) => Object.freeze({ ...defaultPage, ...p }));
    }
    // eslint-disable-next-line class-methods-use-this
    computeToastDuration(toastConfig) {
        if (toastConfig.type === "error") {
            return 0;
        }
        return 3000;
    }
    // eslint-disable-next-line class-methods-use-this
    computeToastMessage(toastConfig) {
        if (toastConfig.type === "error") {
            return `${toastConfig.message} ${toastConfig.id ? `(ID: ${toastConfig.id})` : ""}`;
        }
        return toastConfig.message;
    }
    showToast(config) {
        const { toast } = this.$;
        toast.setAttribute("type", config.type || "info");
        toast.show({
            text: this.computeToastMessage(config),
            duration: this.computeToastDuration(config),
        });
    }
    closeToast() {
        this.$.toast.toggle();
    }
    _dataChange() {
        this.page = "submitted";
    }
    _subrouteChanged() {
        console.log("SubRoute", this.subroute);
    }
    _routeChanged() {
        console.log("Location", this.route);
        console.log("window.location.href", window.location.href);
        const { rwfid } = this.route.__queryParams;
        if (rwfid) {
            this.set("registrationId", rwfid);
        }
    }
    _routeDataChanged() {
        console.log("Route Data", this.routeData);
    }
    logout() {
        this.page = "logout";
    }
    _userTypeChanged(userType) {
        console.log("userType changed:", userType);
        if (userType === "link") {
            this.$.home.setAttribute("disabled", "disabled");
            this.$.profile.setAttribute("disabled", "disabled");
            this.$.roleSelection.setAttribute("disabled", true);
        }
        else {
            this.$.home.removeAttribute("disabled");
            this.$.profile.removeAttribute("disabled");
            this.$.roleSelection.removeAttribute("disabled");
        }
    }
    activeGroupChanged() {
        if (!this.activeGroup || !this.activeGroup.id) {
            return;
        }
        console.log("Active group changed");
        this.url = `${this.apiBaseUrl}/api/v1/groups/${this.activeGroup.id}`;
        this.$.apiRequest.authorizationRequired = true;
        this.$.apiRequest.authorizationType = "resource";
        this.$.apiRequest.manuallyHandleError = true;
        this.$.apiRequest.resource = `/groups/${this.activeGroup.id}`;
        this.$.apiRequest
            .generateApiRequest()
            .then((response) => {
            if (response) {
                const featureAccess = response.featureAccess || [];
                console.log("featureAccess", featureAccess);
                this.set("featureAccess", featureAccess);
                this.set("customConfig", response.customConfig);
            }
        })
            .catch((e) => console.warn(e));
    }
    // eslint-disable-next-line class-methods-use-this
    featureEnabled(featureAccess, feature) {
        return featureAccess.includes(feature);
    }
    _typeChanged() {
        if (this.type) {
            let relRef = "";
            switch (this.type) {
                case "report":
                    relRef = "report";
                    break;
                case "admin":
                    relRef = "admin/groups";
                    break;
                case "upload":
                    relRef = "upload-dashboard";
                    break;
                case "jobs":
                default:
                    relRef = "site-dashboard";
                    break;
            }
            const href = `${this.cdnBaseUrl}${this.rootPath}${relRef}`;
            this.dispatchEvent(new CustomEvent("changeRoute", {
                bubbles: true,
                composed: true,
                detail: {
                    route: href,
                },
            }));
        }
    }
    _routePageChanged(page, oldPage) {
        // Polymer 2.0 will call with `undefined` on initialization.
        // Ignore until we are properly called with a string.
        if (page === undefined) {
            return;
        }
        // If no page was found in the route data, page will be an empty string.
        // Default to 'job dashboard' in that case.
        this.page = page || "homepage";
        console.debug(`Route changed: ${oldPage} -> ${page}`);
        const pageId = this.page;
        console.log("this.subrouteData");
        console.log(this.subrouteData);
        // This is to prevent giving uploader direct access to subRouteId.
        // If it was allowed to bind directly to it, whenever it changes the uploader will react to it
        // e.g. 1. load simple-uploader/job-2
        //      2. load site-viewer/job-3
        //      3. subrouteId changed, uploader reacts to the new id,
        //         checks if job-3 exists for upload and fails (since its not an upload job)
        if (pageId === "simple-uploader") {
            this.uploadJobId = this.subrouteData.id;
        }
        else if (pageId === "site-viewer") {
            [this.siteViewerJobId] = this.subrouteData.id.split("?");
        }
        else if (pageId === "site-documents") {
            this.siteDocumentsJobId = this.subrouteData.id;
        }
        else if (pageId === "groups") {
            // this.groupPageGroupName = this.subrouteData.id;
        }
        if (pageId === "groups") {
            if (this.route.path === "/groups") {
                this.breadcrumbs = "";
            }
            else {
                this.breadcrumbs = this.subrouteData.id;
            }
        }
        else {
            this.breadcrumbs = "";
        }
        // Remove subroute ID on pages where its not required
        if (pageId !== "site-viewer" &&
            pageId !== "simple-uploader" &&
            pageId !== "job-management" &&
            pageId !== "groups" &&
            pageId !== "site-documents" &&
            pageId !== "admin") {
            this.set("hideControls", true);
            this.subrouteData.id = "";
            this.notifyPath("subrouteData.id");
        }
        else {
            this.set("hideControls", false);
            if (!this.controlsOpened)
                this.controlsOpened = true;
        }
        if (pageId === "site-dashboard") {
            this.type = "jobs";
        }
        else if (pageId === "group-management" ||
            pageId === "job-management" ||
            pageId === "groups" ||
            pageId === "admin") {
            this.type = "admin";
        }
        else if (pageId === "upload-dashboard" ||
            this.page === "simple-uploader") {
            this.type = "upload";
        }
        // Pages to Hide the App Header on.
        if (pageId === "register" ||
            pageId === "submitted" ||
            pageId === "login" ||
            pageId === "auth-return" ||
            pageId === "service-login" ||
            pageId === "link" ||
            pageId === "error" ||
            pageId === "contact-us" ||
            pageId === "homepage" ||
            pageId === "resend-verification-email") {
            this._hideAppHeader();
        }
        else {
            this._showAppHeader();
        }
        // Hide recpatcha container when page is not register
        const rc = document.getElementsByClassName("recaptcha-container");
        if (pageId !== "register" && rc[0]) {
            rc[0].style.display = "none";
        }
        else if (pageId === "register" && rc[0]) {
            rc[0].style.display = "block";
        }
    }
    async _pageChanged(pageId) {
        await this.loadPage(pageId);
    }
    async loadPage(pageId) {
        const pageDef = this.pageDefs.find((p) => p.urlPath === pageId) || {
            ...defaultPage,
            urlPath: pageId,
            importPath: `./${pageId}.js`,
        };
        if (pageDef.authRequired && !this.rootStore.auth.hasIdentityAuth()) {
            this.dispatchEvent(new CustomEvent("changeRoute", {
                bubbles: true,
                composed: true,
                detail: {
                    route: "/login",
                    params: {
                        redirect_uri: `${window.location}`,
                    },
                    errorMessage: "You are unauthenticated.\nPlease login or register to continue.",
                },
            }));
            return;
        }
        await pageDef.load();
        // try {
        //     await import(pageDef.importPath);
        // } catch (e) {
        //     this._showPage404(e);
        // }
    }
    _showPage404(reason) {
        console.log("Error Show 404:", reason);
        this.page = "view404";
    }
    checkAdmin() {
        this.adminAuthorized = false;
        // this.url = `${this.apiBaseUrl}/api/v1/admin`;
        // this.authorizationRequired = true;
        // this.authorizationType = null;
        // this.$.apiRequest.generateApiRequest().then((response) => {
        //     this.adminAuthorized = response.admin;
        // });
    }
    static buildAppPermissionsFrom(scope) {
        // we can build onto this as needed
        const upload = scope.includes("jobs.assets.");
        const admin = scope.includes("groups.jobs"); // something like that/ amin page will have it's own stuff
        return { upload, admin };
    }
    async ready() {
        super.ready();
        this.rootStore.app.setAPIBasePath(this.apiBaseUrl);
        this.addEventListener("changeRoute", this._changeRoute);
        this.addEventListener("changeToError", this._changeToError);
        this.addEventListener("toastMessage", (e) => {
            this.showToast(e.detail);
        });
        this.initialiseBanner();
        // const loginPages = ["service-login", "auth-return", "link"]; // NOTE: do we add link login here ?
        // TODO: set resource token type and check refreshTokenCheckActive
        // this.checkForResourceToken();
        if (this.page) {
            await this.loadPage(this.page);
        }
        this._routePageChanged(this.page || "site-dashboard");
        // this._pageChanged(this.page);
        autorun(async () => {
            const isAuthenticated = this.rootStore.auth.hasIdentityAuth();
            if (isAuthenticated)
                this.checkAdmin();
            if (isAuthenticated) {
                await this.getDefaultGroup();
            }
        });
        autorun(async () => {
            if (!this.rootStore.app.activeGroup) {
                return;
            }
            this.set("activeGroup", this.rootStore.app.activeGroup);
            this.notifyPath("activeGroup.id");
            this.notifyPath("activeGroup.name;");
            // Get resource for group data token
            const resource = `/groups/${this.rootStore.app.activeGroup.id}`;
            const resourceAuth = await this.rootStore.auth.getResourceAuth(resource);
            if (!resourceAuth) {
                this.dispatchEvent(new CustomEvent("changeRoute", {
                    bubbles: true,
                    composed: true,
                    detail: {
                        route: "/login",
                        params: {
                            redirect_uri: `${window.location}`,
                        },
                        errorMessage: "You are unauthenticated.\nPlease login or register to continue.",
                    },
                }));
                return;
            }
            const perms = App.buildAppPermissionsFrom(resourceAuth.scope);
            this.set("permissions", perms);
        });
    }
    initialiseBanner() {
        this.banner = new MDCBanner(this.shadowRoot.querySelector(".mdc-banner"));
        // this.banner.button = new MDCButton(this.shadowRoot.querySelector('.mdc-button'));
        if (this.bannerData) {
            this.banner.open();
        }
        afterNextRender(this, this.banner.layout.bind(this.banner));
    }
    bannerDataChanged(newData) {
        if (this.banner) {
            if (newData) {
                this.banner.open();
            }
            else {
                this.banner.close();
            }
        }
    }
    setBanner(title, actions, icon) {
        // if (this.bannerData) {
        //     return;
        // }
        if (!title || title === "") {
            this.set("bannerData", null);
            return;
        }
        this.set("bannerData", {
            icon,
            title,
            actions,
        });
    }
    onBannerAction(e) {
        this.bannerData.actions[e.currentTarget.dataset.actionId].action();
    }
    upgradeAvailableChanged(current, old) {
        if (current === old) {
            return;
        }
        if (!current) {
            this.setBanner(null);
            return;
        }
        console.info(`${this.constructor.is}: Application upgrade available`);
        this.setBanner("An application upgrade is available, reload required. Some features may not work until upgrade", [
            {
                text: "Update Now",
                action: () => {
                    console.info(`${this.constructor.is}: User requested application upgrade`);
                    this.dispatchEvent(new CustomEvent("upgrade-app", {
                        bubbles: true,
                        composed: true,
                    }));
                },
            },
        ]);
    }
    async getDefaultGroup() {
        console.log("Getting default group");
        this.url = `${this.apiBaseUrl}/api/v1/users/me/defaultGroup`;
        this.authorizationRequired = true;
        this.authorizationType = null;
        const response = await this.$.apiRequest.generateApiRequest();
        const { id, displayName } = response;
        this.rootStore.app.setActiveGroup(new Group(id, displayName));
    }
    _hideAppHeader() {
        this.$.appHeader.style.display = "none";
        this.$.appHeaderLayout.resetLayout();
    }
    _showAppHeader() {
        this.$.appHeader.style.display = "inline";
        this.$.appHeaderLayout.resetLayout();
    }
    _changeToError(e) {
        if (e.detail.data &&
            e.detail.data.error &&
            e.detail.data.pageFrom &&
            e.detail.data.pageFrom !== "/") {
            // Only change to the error page if you are not already on the error page.
            // This prevents the error page changing between errors.
            // e.g. if three API requests all error, then the error page will quickly cycle between three error pages.
            // Now the first error to occur will simply be displayed.
            if (this.page !== "error") {
                this.error = e.detail.data.error;
                this.page = "error";
                this._hideAppHeader();
            }
        }
    }
    static removeHash() {
        const loc = window.location;
        if ("pushState" in window.history) {
            window.history.replaceState("", document.title, loc.pathname + loc.search);
        }
    }
    _changeRoute(e) {
        if (e.detail.params && e.detail.params.redirect_uri) {
            this.authReturnRedirectUri = e.detail.params.redirect_uri;
        }
        if (e.detail.errorMessage) {
            this.errorMessage = e.detail.errorMessage;
        }
        if (e.detail.data) {
            if (e.detail.data.groupId)
                this.groupId = e.detail.data.groupId;
            if (e.detail.data.groupName)
                this.groupName = e.detail.data.groupName;
            if (e.detail.data.error)
                this.error = e.detail.data.error;
        }
        window.history.pushState({}, null, e.detail.route);
        window.dispatchEvent(new CustomEvent("location-changed"));
        if (e.detail.removeHash !== false) {
            App.removeHash();
        }
    }
    dispatchError(error) {
        console.log("Dispatching");
        this.dispatchEvent(new CustomEvent("changeToError", {
            bubbles: true,
            composed: true,
            detail: {
                route: `error`,
                data: {
                    error,
                    pageFrom: window.location.pathname,
                },
            },
        }));
    }
    static handleErrors(response) {
        if (!response.ok)
            throw response;
        else
            return response;
    }
}
window.customElements.define(App.is, App);
//# sourceMappingURL=app.js.map